import NavMenuItem from "../ui/nav-menu-item";
import { useState, useContext } from "react";
import SearchModal from "./search-modal";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import TableContext from "../../contexts/table-context";
import { useRouter } from "next/router";
import { Search } from "lucide-react";
import NavSection from "./nav-section";
import Tooltips from "../ui/tooltip";
import ActionIcon from "../ui/action-icon";
import { isPegInstalled } from "../../lib/auth";
import Staging from "./staging";

const NavMenuItems = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    workpegAI: false,
    dashboard: false,
  });
  const router = useRouter();
  const userCtx = useContext(UserContext);
  const user = userCtx.user;
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  const isDeveloperRegistered = businessCtx.isDeveloperRegistered;





  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDropdown = (dropdown) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  }
  if (isDeveloperRegistered === null) {
    return null;
  }

  if (user.is_pseudonymous || business.is_pseudonymous || router.asPath == `/${router.query.uuid}/onboarding`) {
    return (
      <div className="grid gap-[4px] content-start max-h-[70dvh] overflow-y-scroll scrollbar-none">
        <span className="px-[27px] text-[12px] custom-text-grey-800  poppins-regular">
          Get Started
        </span>
        <NavMenuItem icon="badge-check" href="/onboarding">
          Onboard
        </NavMenuItem>
      </div>
    );
  }
  return (
    <div className="grid gap-[4px] content-start min-h-[200px] ">
      <Tooltips position="right" content="This feature is coming soon">
        <div
          // onClick={toggleModal}
          className={`grid grid-flow-col justify-start items-center cursor-not-allowed w-full text-[12px] h-[35px] px-[27px] gap-[12px] rounded-[8px] custom-text-grey-800 `}>
          <ActionIcon color="custom-text-grey-800 !cursor-not-allowed">
            <Search size={16} color="currentColor" />
          </ActionIcon>
          <span className={`custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px]`}>Search</span>
        </div>
      </Tooltips>
      <NavMenuItem icon="sparkles" href="/chats" history>
        Workpeg AI
      </NavMenuItem>
      <NavMenuItem icon="house" href="/dashboard">
        Dashboard
      </NavMenuItem>
      <NavSection>
        <NavMenuItem icon='layout-grid' href='/pegs'>
          Pegs
        </NavMenuItem>
      </NavSection>
    </div>
  );
};

export default NavMenuItems;
